<!-- /* * Confidential and Proprietary. * Do not distribute without 1-800-Flowers.com, Inc. consent. *
Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved. */ -->

<a
	class="survey-button"
	{href}
	target="_blank"
	rel="noopener noreferrer"
	on:click={handleSurveyClicked}
>
	<div class="survey-content">
		<span class="survey-text">How did we do?</span>
		<span class="survey-subtext">We value your feedback</span>
	</div>
	{#if brandImage}
		<img src={brandImage} alt="Survey Icon" class="survey-icon" />
	{/if}
</a>

<script lang="ts">
	import { chatSession, surveySent } from '$lib/stores/chatSessionStore';
	import { onMount } from 'svelte';
	import { brandLogos } from '../../utilities/brandingConfigurations';
	import { socketDisconnect } from '$lib/stores/websocketStore';
	import { datadogLogs } from '@datadog/browser-logs';

	let brandImage = brandLogos[$chatSession.brand as keyof typeof brandLogos] || brandLogos['18F'];
	export let href = '';

	function handleSurveyClicked(event: MouseEvent) {
		datadogLogs.logger.info(
			`[Conv-ui] Survey Submitted - brand: ${$chatSession.brand} channel: ${$chatSession.channel} browser_uuid: ${$chatSession.browseruuid} conversation_id: ${$chatSession?.conversation_id}`
		);
	}
	const setSurvey = async () => {
		socketDisconnect();
		surveySent.set(true);
	};

	onMount(() => {
		const mount = async () => {
			await setSurvey();
		};
		mount();
	});
</script>

<style>
	.survey-button {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px 12px;
		border-radius: 5px;
		box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
		background-color: #f5f5f5;
		text-decoration: none;
		width: 75%;
		margin: 10px auto;
	}

	.survey-content {
		display: flex;
		flex-direction: column;
	}

	.survey-text {
		font-family: area-variable, sans-serif;
		font-style: normal;
		font-variation-settings:
			'INKT' 0,
			'slnt' 0,
			'wdth' 100,
			'wght' 100;
		font-size: 14px;
		font-weight: bold;
		color: #333;
	}

	.survey-subtext {
		font-family: area-variable, sans-serif;
		font-style: normal;
		font-variation-settings:
			'INKT' 0,
			'slnt' 0,
			'wdth' 100,
			'wght' 100;
		font-size: 12px;
		color: #777;
	}

	.survey-icon {
		width: 100px;
		height: 40px;
	}
</style>
